import type { FC } from 'react'

import Modal from 'views/components/molecules/Modal'

import AppliedPromotionInformationModalContent from './AppliedPromotionInformationModalContent'
import { APPLIED_PROMOTION_INFORMATION_MODAL } from './names'

export type AppliedPromotionInformationModalProps = {
  title: string
  open?: boolean
}

const AppliedPromotionInformationModal: FC<
  AppliedPromotionInformationModalProps
> = ({ open, title }) => {
  return (
    <Modal
      size="medium"
      id={APPLIED_PROMOTION_INFORMATION_MODAL}
      title={title}
      isClientSideControlled
      open={open}
    >
      <AppliedPromotionInformationModalContent />
    </Modal>
  )
}

export default AppliedPromotionInformationModal
